import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from '../translations/DeadlinesCheckModal.translations.json';
import { useCallback } from 'react';
import { Alert, Flex } from 'antd';
import { Form, FormDateRangePicker, FormField } from '../../common/form';
import {
  ActionButton,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Padding,
} from '../../common/components';
import { Modal } from '../../common/components/modal/Modal';
import { DeadlineCheckFormType } from '../schema';
import { DeadlineCheckFormSchema } from '../schema/DeadlineCheckFormSchema';
import * as Icon from 'react-feather';
import { ISODate } from '../../common/utils';

const { addTranslations, t } = i18nNsFactory('deadlines-check-modal');
addTranslations(translations);

export interface DeadlinesCheckModalProps {
  onCancel: () => void;
  onCheck: (dateRange: [ISODate, ISODate]) => void;
  checkError?: string;
  isValidating?: boolean;
}

export function DeadlinesCheckModal({
  onCancel,
  onCheck,
  checkError,
  isValidating,
}: DeadlinesCheckModalProps) {
  const handleSubmit = useCallback(
    ({ dateRange }: DeadlineCheckFormType) => {
      onCheck(dateRange);
    },
    [onCheck],
  );

  return (
    <Modal onCancel={onCancel} width="50rem" footer={null}>
      <ModalHeader>
        <ModalTitle>{t('title')}</ModalTitle>
        {checkError && (
          <Padding top={8}>
            <Alert
              type="error"
              icon={<Icon.AlertTriangle />}
              showIcon
              message={checkError}
              banner
            />
          </Padding>
        )}
      </ModalHeader>
      <Form
        onSubmit={handleSubmit}
        schema={DeadlineCheckFormSchema}
        defaultValues={{}}
      >
        <Padding scrollable>
          <Flex vertical gap="large">
            <FormField
              name="dateRange"
              label={t('fields.dateRange.label')}
              required
            >
              <FormDateRangePicker
                name="dateRange"
                style={{ width: '25rem' }}
              />
            </FormField>
          </Flex>
        </Padding>
        <ModalFooter>
          <Flex justify="end" gap="small">
            <ActionButton
              type="abort"
              onClick={onCancel}
              disabled={isValidating}
            />
            <ActionButton
              label={t('buttons.submit')}
              type="formSubmit"
              loading={isValidating}
            />
          </Flex>
        </ModalFooter>
      </Form>
    </Modal>
  );
}
